module.exports = __webpack_public_path__ + "static/video-context-menu-e06614f7ed3bfd4f19a59f772ff7e827.mp4";